module.exports = __webpack_public_path__ + "static/media/room3_3.302d8820.JPG";